export const restApiUri = process.env.REACT_APP_URL;
